export enum LocalStorage {
  AUTH_TOKEN = 'auth_token',
  USER_EMAIL = 'user_email',
  EXPIRATION_DATE = 'expiration_date',
  FIRST_LOGIN_TOKEN = 'first_login_token',
  INTERESTED_IN = 'interested_in',
  POSTCODE = 'postcode',
  REGISTRATION_URL = 'registration_url',
  COUNTRY_CODE = 'country_code',
  CONSENT_STORAGE_KEY = 'cookie_consent_granted',
  HUBSPOT_TOKEN = 'hubspot_token',
  HUBSPOT_TOKEN_EXPIRATION = 'hubspot_token_expiration',
}
